import { render } from "./LimitLocationsMaxCapTable.vue?vue&type=template&id=9d5c0982"
import script from "./LimitLocationsMaxCapTable.vue?vue&type=script&lang=js"
export * from "./LimitLocationsMaxCapTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__